export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14810.902816ce.jpg";